import usePermittedQuery from '_api/queries/usePermittedQuery';
import { ResourceSetting } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_ALL_PATIENT_RESOURCES_BY_ID_KEY = 'get-all-patient-resources-by-id';

export const useGetAllPatientResourcesByID = (patientId: number) => {
  return usePermittedQuery<ResourceSetting[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/resource/get-all-patient-resource/${patientId}`,
    {},
    [GET_ALL_PATIENT_RESOURCES_BY_ID_KEY, patientId],
    {
      enabled: typeof patientId === 'number' && patientId > 0,
      refetchOnWindowFocus: false,
    },
  );
};
